module.exports = __webpack_public_path__ + "static/img/manual-18.94f8784.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/en/manual-18.png
// module id = 4vUT
// module chunks = 4